<div class="mapping-container" id="categoryMappingContainer">
  <dx-load-panel [visible]="aiMappingRunning && !mappingJobId"
                 [delay]="1000"
                 [position]="{ of: '#categoryMappingContainer' }"
                 [hideOnOutsideClick]="false"
                 [message]="'Automatische Zuordnung läuft...' | translate">
  </dx-load-panel>

  <div class="mapping-header">
    <div class="card-header mapping-header-left">
      {{ 'Import Kategorien' | translate }}
    </div>
    <div class="card-header mapping-header-right">
      {{ 'Golden Record Kategorien' | translate }}
      <np-ai-button [text]="'Automatisch zuordnen' | translate"
                    [disabled]="aiMappingRunning"
                    (clicked)="runAutoMapping()">
      </np-ai-button>
    </div>
  </div>

  <dx-tree-list #treeList
                class="mapping-treelist"
                [dataSource]="rows"
                keyExpr="id"
                parentIdExpr="parent"
                [showBorders]="false"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [autoExpandAll]="false"
                [showColumnHeaders]="false"
                [showColumnLines]="false"
                [rowAlternationEnabled]="true"
                [hoverStateEnabled]="true"
                [remoteOperations]="{ filtering: true }"
                hasItemsExpr="hasChilds"
                rootValue="0">

    <dxo-scrolling mode="virtual"></dxo-scrolling>

    <dxi-column dataField="text"
                width="30%"
                [allowSorting]="false"
                [allowFiltering]="false"
                cellTemplate="importCell">
    </dxi-column>

    <dxi-column dataField="goldenRecordCategoryStableId"
                width="30%"
                [allowSorting]="false"
                [allowFiltering]="false"
                cellTemplate="mappingCell">
    </dxi-column>

    <!--<dxi-column width="40%"></dxi-column>-->

    <div *dxTemplate="let cell of 'importCell'">
      <div class="import-cell">
        <span class="level-badge"
              [ngClass]="'level-' + cell.row.level">
          {{ cell.row.level + 1 }}
        </span>
        <span class="import-name">
          {{ cell.data.text }}
        </span>
      </div>
    </div>
    <div *dxTemplate="let cell of 'mappingCell'">
      <div *ngIf="cell.data.type != 'cat'" class="mapping-cell">
        <dx-select-box
            class="mapping-select"
            [dataSource]="goldenRecordCategoryDataSource"
            displayExpr="groupString"
            valueExpr="stableId"
            [searchEnabled]="true"
            searchExpr="groupString"
            searchMode="contains"
            [minSearchLength]="0"
            [searchTimeout]="300"
            [(value)]="cell.data.goldenRecordCategoryStableId"
            (onValueChanged)="onMappingChanged(cell, $event)"
            [showClearButton]="true">
          <div *dxTemplate="let item of 'item'">
            <div [title]="item.groupString"
                 style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ item.groupString }}
            </div>
          </div>
        </dx-select-box>

        <np-ai-button *ngIf="!cell.data.goldenRecordCategoryStableId"
                      [hint]="'Diese Kategorie automatisch zuordnen' | translate"
                      [disabled]="aiMappingRunning"
                      (clicked)="runAutoMappingFor(cell.data)">
        </np-ai-button>

        <div *ngIf="cell.data.goldenRecordCategoryStableId && cell.data.type != 'cat'">
          <dx-button icon="overflow"
                     stylingMode="text"
                     (onClick)="openRowMenu($event, cell)">
          </dx-button>
        </div>
      </div>
    </div>

    <div *dxTemplate="let cell of 'actionsCell'">
      <div *ngIf="cell.data.goldenRecordCategoryStableId && cell.data.type != 'cat'" class="mapping-cell">
        <dx-button icon="overflow"
                   stylingMode="text"
                   (onClick)="openRowMenu($event, cell)">
        </dx-button>
      </div>
    </div>
  </dx-tree-list>

  <dx-context-menu
      #rowMenu
      [width]="200"
      [showEvent]="''"
      [position]="{ my: 'left top', at: 'left bottom' }"
      (onItemClick)="onMenuItemClick($event)">
    <dxi-item text="Kategorie hinzufügen"></dxi-item>
  </dx-context-menu>

</div>

<dx-popup height="auto"
          width="400"
          [showTitle]="true"
          title="{{ 'Kategorie hinzufügen' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="addCategoryVisible"
>
  <dxi-popup-toolbar-item
      toolbar="bottom"
      location="after"
      widget="dxButton"
      [options]="{ stylingMode: 'outlined', text: 'Kategorie hinzufügen' | translate, onClick: addCategory }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
      toolbar="bottom"
      location="after"
      widget="dxButton"
      [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: hideAddCategory }"
  ></dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view>
      <dx-validation-group class="w-100" #addAccountValidationGroup>
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">{{ 'Name' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  [(value)]="newCategoryName"
                  [showClearButton]="true"
                  valueChangeEvent="focusout"
              >
                <dx-validator>
                  <dxi-validation-rule type="required" message="{{ 'Bitte Namen eingeben' | translate }}"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </div>
        </div>
      </dx-validation-group>
    </dx-scroll-view>
  </div>
</dx-popup>
